module.exports = __webpack_public_path__ + "media/cjWarn.e03827e1.mp3";